import ReactDom from "react-dom";
import { IoMdCloseCircle } from "react-icons/io";
import "./AddOptionsPortal.scss";
export const AddOptionsPortal = ({
  open,
  children,
  onClose,
  TypeOfPortal,
}) => {
  if (!open) return null;
  return ReactDom.createPortal(
    <>
      <div>
        <div className={open ? "myModal" : "modal"}>
          <div className="content">
            <div className="">
              <div className="Flex">
                <span>{TypeOfPortal}</span>
                <span onClick={() => onClose()}>
                  <IoMdCloseCircle className="closeIcon" />
                </span>
              </div>
              <div>{children}</div>
            </div>
          </div>
        </div>
      </div>
    </>,
    document.getElementById("modal-root")
  );
};
